import { apiCall } from '../../utils/restclient'
import {
  EDIT_ADMIN_PASSWORD,
  EDIT_ADMIN_PASSWORD_ERROR,
  EDIT_ADMIN_PASSWORD_SUCCESS,
  GET_ADMIN_PROFILE,
  GET_ADMIN_PROFILE_ERROR,
  GET_ADMIN_PROFILE_SUCCESS,
  SET_ADMIN_PROFILE,
  SET_ADMIN_PROFILE_ERROR,
  SET_ADMIN_PROFILE_SUCCESS,
  SET_CURRENT_PROFILE_IMG,
  SET_CURRENT_PROFILE_IMG_ERROR,
  SET_CURRENT_PROFILE_IMG_SUCCESS,
} from './AccountSettingsConstants'

export const getAdminProfile = () => {
  const endpoint = `api/v1/profile`
  const action = {
    type: GET_ADMIN_PROFILE,
  }
  try {
    // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
    apiCall(endpoint, 'GET', null, null, {
      success: GET_ADMIN_PROFILE_SUCCESS,
      error: GET_ADMIN_PROFILE_ERROR,
    })
    return action
  } catch (e) {
    console.log(e)
  }
}

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const setAdminProfile = (newAdminProfile) => {
  const endpoint = `api/v1/profile`
  const action = {
    type: SET_ADMIN_PROFILE,
  }
  try {
    // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
    apiCall(endpoint, 'PUT', null, JSON.stringify(newAdminProfile), {
      success: SET_ADMIN_PROFILE_SUCCESS,
      error: SET_ADMIN_PROFILE_ERROR,
      extraData: { newAdminProfile },
    })
    return action
  } catch (e) {
    console.log(e)
  }
}
// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const setCurrentProfileImage = (img) => {
  const endpoint = `api/v1/profile/image`
  const action = {
    type: SET_CURRENT_PROFILE_IMG,
  }
  try {
    apiCall(
      endpoint,
      'PUT',
      null,
      img,
      // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
      {
        success: SET_CURRENT_PROFILE_IMG_SUCCESS,
        error: SET_CURRENT_PROFILE_IMG_ERROR,
      },
      null,
      {},
    )
    return action
  } catch (e) {
    console.log(e)
  }
}

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const editAdminPassword = (editedBody) => {
  const endpoint = `api/v1/profile/password`
  const action = {
    type: EDIT_ADMIN_PASSWORD,
  }
  try {
    // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
    apiCall(endpoint, 'PUT', null, JSON.stringify(editedBody), {
      success: EDIT_ADMIN_PASSWORD_SUCCESS,
      error: EDIT_ADMIN_PASSWORD_ERROR,
    })
    return action
  } catch (e) {
    console.log(e)
  }
}
